export { default } from 'features/reward/routes/challenge-details-route';
